import script from "./PUR03_005INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR03_005INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__